var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDraftingCompass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.472,
    height: 13.472,
    viewBox: "0 0 13.472 13.472",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "drafting-compass",
    d: "M12.025,9.062a8.344,8.344,0,0,1-2.172,1.291l1.431,2.478,1.419.606a.421.421,0,0,0,.583-.337l.185-1.533L12.025,9.062Zm1.118-2.488a.422.422,0,0,0-.159-.589l-.739-.41a.422.422,0,0,0-.559.15A5.9,5.9,0,0,1,6.736,8.42a5.847,5.847,0,0,1-1.826-.3l1.772-3.07c.018,0,.035.006.054.006s.036,0,.054-.006L8.133,7.375a5.014,5.014,0,0,0,2.174-1.287L8.945,3.727a2.492,2.492,0,0,0,.317-1.2,2.526,2.526,0,0,0-5.052,0,2.5,2.5,0,0,0,.317,1.2L2.73,6.84a5.88,5.88,0,0,1-.886-1.026.422.422,0,0,0-.562-.14L.551,6.1A.422.422,0,0,0,.4,6.688,7.551,7.551,0,0,0,1.876,8.32L0,11.569.185,13.1a.421.421,0,0,0,.583.337l1.419-.606L4.051,9.605a7.555,7.555,0,0,0,9.092-3.031ZM6.736,1.684a.842.842,0,1,1-.842.842A.842.842,0,0,1,6.736,1.684Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDraftingCompass);
export default __webpack_public_path__ + "static/media/drafting-compass.69ba04b62ed4e28abe6fca18cd15ccdf.svg";
export { ForwardRef as ReactComponent };